import React, { useState } from "react";
import { Button } from "@material-ui/core";
import { ImagePreview, PhotoButton, PhotoButtons, UploadContainer, UploadField } from "./styles";

const FileUpload = ({ onFileUpload, setMode }) => {
    const [file, setFile] = useState(null);
    const [image, setImage] = useState(null);

    const handleFileChange = (event) => {
        setFile(event.target.files[0]);
        setImage(URL.createObjectURL(event.target.files[0]));
        setMode("upload");
    };

    const handleReset = (event) => {
        event.target.value = null;
        setFile(null);
        setImage(null);
        setMode(null);
    };

    const handleUpload = () => {
        if (file) {
            onFileUpload(file);
        }
    };

    return (
        <UploadContainer>
            {file && image && (
                <ImagePreview>
                    <img alt="Uploaded Preview" src={image} width={600} height={600} />
                </ImagePreview>
            )}
            <UploadField>
                <input
                    type="file"
                    accept="image/*"
                    onChange={handleFileChange}
                    style={{ display: "none" }}
                    id="file-upload"
                />
                {file && image ? (
                    <div>
                        <p>{file.name}</p>
                        <PhotoButtons>
                            <PhotoButton>
                                <Button fullWidth variant="contained" color="primary" onClick={handleUpload}>
                                    Enviar
                                </Button>
                            </PhotoButton>
                            <PhotoButton>
                                <Button fullWidth variant="contained" color="secondary" onClick={handleReset}>
                                    Trocar
                                </Button>
                            </PhotoButton>
                        </PhotoButtons>
                    </div>
                ) : (
                    <PhotoButton>
                        <label htmlFor="file-upload">
                            <Button fullWidth variant="contained" color="primary" component="span">
                                Escolher Arquivo
                            </Button>
                        </label>
                    </PhotoButton>
                )}
            </UploadField>
        </UploadContainer>
    );
};

export default FileUpload;
